import { NormApi } from '@/api/norm'
import { getLiffApiHeaders } from '@/utils/apiConfig'
import { IForm, IFormListRequest, IOverViewRequest, IDynamicLiffFormDetail } from '@/utils/types'

export class FormApi extends NormApi<IForm> {
  list = async (params: IFormListRequest) => {
    const response = await this.axios.get('/v1/forms', {
      params,
    })
    return this.responseHandler(response)
  }

  single = async (id: string) => {
    const response = await this.axios.get(`/v1/forms/${id}`)
    return this.responseHandler(response)
  }

  singlePublic = async (id: string) => {
    const response = await this.axios.get(`/v1/forms/${id}/public`, {
      headers: getLiffApiHeaders(),
    })
    return this.responseHandler(response)
  }

  add = async (payload: IForm) => {
    const response = await this.axios.post('/v1/forms/add', payload)
    return this.responseHandler(response)
  }

  update = async (payload: IForm) => {
    const { _id, ...updateData } = payload
    const response = await this.axios.put(`/v1/forms/${_id}`, updateData)
    return this.responseHandler(response)
  }

  activateLIFF = async (payload: IForm) => {
    const { _id } = payload
    const response = await this.axios.post(`/v1/forms/${_id}/liff`)
    return this.responseHandler(response)
  }

  delete = async (id: string) => {
    const response = await this.axios.delete(`/v1/forms/${id}`)
    return this.responseHandler(response)
  }

  clone = async (id: string) => {
    const response = await this.axios.post(`/v1/forms/clone/${id}`)
    return this.responseHandler(response)
  }

  assetOverviewDetail = async (payload: IOverViewRequest) => {
    const response = await this.axios.post('/v1/asset/detail-overview', payload)
    return this.responseHandler(response)
  }

  submitFormPublic = async (payload: IDynamicLiffFormDetail) => {
    const response = await this.axios.post('/v1/forms/liff-answer/public', payload, {
      headers: getLiffApiHeaders(),
    })
    return this.responseHandler(response)
  }
}

const Form = new FormApi()
export default Form
